export const leftBranch = (currentNode, baseTreePath = '') => {
  let branch = []
  let treePath = baseTreePath.split('.')
  let nextNode
  while (currentNode) {
    // If the node doesn't render to screen, we need to assume its always valid
    treePath.push(currentNode.id)
    currentNode.treePath = treePath.join('.')
    branch.push(currentNode)
    if (currentNode.children) {
      nextNode = currentNode.children[0]
      if (currentNode.value === undefined) currentNode.value = nextNode.id
      currentNode = nextNode
    } else currentNode = null
  }
  return branch
}

export const rightBranch = (currentNode, baseTreePath = '') => {
  let branch = []
  let treePath = baseTreePath.split('.')
  let nextNode
  while (currentNode) {
    // If the node doesn't render to screen, we need to assume its always valid
    treePath.push(currentNode.id)
    currentNode.treePath = treePath.join('.')
    branch.push(currentNode)
    if (currentNode.children) {
      nextNode = currentNode.children[currentNode.children.length - 1]
      currentNode.value = nextNode.id
      currentNode = nextNode
    } else currentNode = null
  }
  return branch
}
